angular.module('unica_room.room_services')

.factory('RoomCreateService', function($http, getBaseApiURL) {

	var roomCreateService = {};

	roomCreateService.create = function(roomData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/create',
			data: roomData
		}).then(function(result) {

			if ( result ) {
				return result.data.room;
			}

		});
	};

	return roomCreateService;

})
;